module.exports = __webpack_public_path__ + "img/需協助製作廣告-廣告說明(製作規格).ded94e01.jpg";